import { TabListProps } from './TabList';
import { Theme, css } from '@emotion/react';

export const tabsBase = ({ colors, spacing }: Theme, fullWidth: TabListProps['fullWidth']) => css`
  display: ${fullWidth ? 'grid' : 'inline-grid'};
  width: ${fullWidth ? '100%' : 'inherit'};
  grid-auto-flow: column;
  gap: ${spacing(3)}px;
`;

export const tabsContainer = (
  { colors }: Theme,
  contained: TabListProps['contained'],
  centered: TabListProps['centered']
) => css`
  display: flex;
  ${contained &&
  `
  border-bottom: 1px solid ${colors.borderDefault};
  `}
  ${centered &&
  `
	 justify-content: center;
	`}
`;
